import {Campaign} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/campaign.types';
import {GetDiscountsResponse_Discount} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/campaigns/v1/service.types';
import {DiscountCategory} from './enums/DiscountCategory';

const getCampaignType = (
  campaign: Campaign,
): DiscountCategory.major | DiscountCategory.minor => {
  switch (campaign.type?.$case) {
    case 'minor':
      return DiscountCategory.minor;
    case 'reduction':
    default:
      return DiscountCategory.major;
  }
};

export const getTrackingDiscountType = (
  discountType: GetDiscountsResponse_Discount,
): DiscountCategory => {
  if (discountType) {
    return getCampaignType(discountType.campaign);
  }

  return DiscountCategory.personalized;
};
